import { create } from 'zustand';

type AUSRunState = {
  isRunningAUS: boolean;
  setIsRunningAUS: (value: boolean) => void;
  isAUSRunSuccessful: boolean | null;
  setIsAUSRunSuccessful: (value: boolean | null) => void;
  isAUSRunError: boolean | null;
  setIsAUSRunError: (value: boolean | null) => void;
  ausRunStatus: string | null;
  setAusRunStatus: (value: string | null) => void;
  isAUSLoaderVisible: boolean;
  setIsAUSLoaderVisible?: (value: boolean) => void;
  isAUSStatusNew: boolean;
  setIsAUSStatusNew?: (value: boolean) => void;
  creditOption: string;
  setCreditOption?: (value: string) => void;
  backToRunAUS: () => void;
  ausRunStartedState: (lastRunAUSStatus: string | null) => void;
  ausRunSuccessState: () => void;
  ausRunErrorState: () => void;
  ausCompleteState: () => void;
  historyType: 'DU' | 'LPA';
  setHistoryType: (value: 'DU' | 'LPA') => void;
  showBothTables: boolean;
  setShowBothTables: (value: boolean) => void;
  useBrokerCredentials: boolean;
  setUseBrokerCredentials?: (value: boolean) => void;
  ausDetailsLoading?: boolean;
  setAusDetailsLoading?: (value: boolean) => void;
};

const useAUSStore = create<AUSRunState>((set) => ({
  isRunningAUS: false,
  setIsRunningAUS: (value) => set({ isRunningAUS: value }),
  isAUSRunSuccessful: null,
  setIsAUSRunSuccessful: (value) => set({ isAUSRunSuccessful: value }),
  isAUSRunError: null,
  setIsAUSRunError: (value) => set({ isAUSRunError: value }),
  ausRunStatus: null,
  setAusRunStatus: (value) => set({ ausRunStatus: value }),
  isAUSLoaderVisible: false,
  setIsAUSLoaderVisible: (value) => set({ isAUSLoaderVisible: value }),
  isAUSStatusNew: false,
  setIsAUSStatusNew: (value) => set({ isAUSStatusNew: value }),
  creditOption: 'existing',
  setCreditOption: (value) => set({ creditOption: value }),
  backToRunAUS: () => {
    set({
      isAUSLoaderVisible: false,
      isAUSRunSuccessful: null,
      isAUSStatusNew: false,
      creditOption: 'existing',
    });
  },
  ausRunStartedState: (lastRunAUSStatus: string | null) => {
    set({
      ausDetailsLoading: true,
      isAUSRunError: false,
      isAUSLoaderVisible: true,
      isRunningAUS: true,
      ausRunStatus: lastRunAUSStatus,
    });
  },
  ausRunSuccessState: () => {
    set({
      ausDetailsLoading: true,
      isAUSRunSuccessful: null,
      isAUSStatusNew: false,
    });
  },
  ausRunErrorState: () => {
    set({
      isRunningAUS: false,
      isAUSRunSuccessful: null,
      isAUSRunError: true,
      isAUSLoaderVisible: false,
      ausDetailsLoading: false,
    });
  },
  ausCompleteState: () => {
    set({
      isRunningAUS: false,
      isAUSRunSuccessful: true,
      isAUSRunError: null,
      isAUSStatusNew: true,
      ausDetailsLoading: false,
    });
  },
  historyType: 'DU',
  setHistoryType: (value) => set({ historyType: value }),
  showBothTables: false,
  setShowBothTables: (value) => set({ showBothTables: value }),
  useBrokerCredentials: false,
  setUseBrokerCredentials: (value) => set({ useBrokerCredentials: value }),
  ausDetailsLoading: false,
  setAusDetailsLoading: (value) => set({ ausDetailsLoading: value }),
}));

export default useAUSStore;
